module.exports = __webpack_public_path__ + "img/scythe-gold.fecfe7c9.svg";